import styled from "styled-components";

export const WeekdayPickerStyle = {
    Container: styled.div``
}
